import React from 'react'
import TextInput from '../../common/TextInput'
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown'
import ToggleSwitch from '../../common/ToggleSwitch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'

function RawMaterialSampleEntryInputs(props) {
    return (
        <>
            <div className='raw-sample-inner grid grid-cols-4 gap-2.5'>
                <div className='input-grp'>
                    <label>Ref No</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="refNo"
                        name="refNo"
                        value={props.sampleObject.refNo}
                        onChange={(event) => props.handleChange(event, "refNo")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Ref. Date</label>
                    <TextInput
                        className="inputFocus"
                        type="date"
                        id="refDate"
                        name="refDate"
                        value={props.sampleObject.refDate}
                        onChange={(event) => props.handleChange(event, "refDate")}
                    />
                </div>
                <div className='input-grp'>
                    <label>{props.sampleEntryType === 'FinishProducts' ? 'Prod No' : 'GRN No'} </label>
                    {props.sampleEntryType === 'FinishProducts' ?
                        <TextInput
                            className="inputFocus"
                            type="text"
                            id="prodNo"
                            name="prodNo"
                            value={props.sampleObject.prodNo}
                            onChange={(event) => props.handleChange(event, "prodNo")}
                            disabled
                        />
                        :
                        <TextInput
                            className={`inputFocus ${props.validState?.error?.grnNo ? "errorInput" : ""}`}
                            type="text"
                            id="grnNo"
                            name="grnNo"
                            value={props.sampleObject.grnNo}
                            onChange={(event) => props.handleChange(event, "grnNo")}
                            disabled
                        />}
                </div>
                <div className='btn-grp flex items-center gap-5 mt-2.5 pt-2.5'>
                    <button
                        className='search-btn'
                        onClick={props.getGRNItemsByGRNNo}
                    >
                        {props.sampleEntryType === 'FinishProducts' ? 'Finish Product' : 'GRN'} &nbsp;<FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    </button>
                </div>
            </div>
            <div className='raw-sample-inner grid grid-cols-4 gap-2.5 mt-2.5'>
                <div className='input-grp'>
                    <label>Received Date</label>
                    <TextInput
                        className="inputFocus"
                        type="date"
                        id="receivedDate"
                        name="receivedDate"
                        value={props.sampleObject.receivedDate}
                        onChange={(event) => props.handleChange(event, "receivedDate")}
                        disabled
                    />
                </div>
                <div className='input-grp col-span-2'>
                    <label>{props.sampleEntryType === 'FinishProducts' ? 'Product Name' : 'Material Name'}</label>
                    <MultiSelectDropdown
                        drpIdentity="materialId"
                        options={props.materialList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParametersForItemName(selected, "materialId")
                        }
                        className={props.validState?.error?.materialId ? "errorInput" : ""}
                        allowSelectAll={false}
                        value={props.materialList.filter(
                            (party) => party.value === props.sampleObject.materialId
                        )}
                        isDisabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Standard</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="standard"
                        name="standard"
                        value={props.sampleObject.standard}
                        onChange={(event) => props.handleChange(event, "standard")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Batch No</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="batchNo"
                        name="batchNo"
                        value={props.sampleObject.batchNo}
                        onChange={(event) => props.handleChange(event, "batchNo")}
                        disabled
                    />
                </div>
                {props.sampleEntryType !== 'FinishProducts' ?
                    <>
                        <div className='input-grp'>
                            <label>Chln/Invoice No</label>
                            <TextInput
                                className="inputFocus"
                                type="text"
                                id="invoiceNo"
                                name="invoiceNo"
                                value={props.sampleObject.invoiceNo}
                                onChange={(event) => props.handleChange(event, "invoiceNo")}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Chln/Invoice Date</label>
                            <TextInput
                                className="inputFocus"
                                type="date"
                                id="invoiceDate"
                                name="invoiceDate"
                                value={props.sampleObject.invoiceDate}
                                onChange={(event) => props.handleChange(event, "invoiceDate")}
                                disabled
                            />
                        </div>
                    </>
                    : null
                }
                <div className='input-grp'>
                    <label>Sample Qty {props?.sampleObject?.uom ? `(in ${props.sampleObject.uom})` : ''}</label>
                    <TextInput
                        className={`inputFocus ${props.validState?.error?.sampleQty ? "errorInput" : ""}`}
                        type="number"
                        id="sampleQty"
                        name="sampleQty"
                        value={props.sampleObject.sampleQty}
                        onChange={(event) => props.handleChange(event, "sampleQty")}
                    />
                </div>
                <div className='input-grp'>
                    <label>{props.sampleEntryType === 'FinishProducts' ? "Batch Size" : "Purchase Qty"}</label>
                    <TextInput
                        className="inputFocus"
                        type="number"
                        id="purchaseQty"
                        name="purchaseQty"
                        value={props.sampleObject.purchaseQty}
                        onChange={(event) => props.handleChange(event, "purchaseQty")}
                        disabled
                    />
                </div>
                {props.sampleEntryType === 'FinishProducts' ? null
                    :
                    <div className='input-grp'>
                        <label>UOM</label>
                        <TextInput
                            className="inputFocus"
                            type="text"
                            id="uom"
                            name="uom"
                            value={props.sampleObject.uom}
                            onChange={(event) => props.handleChange(event, "uom")}
                            disabled
                        />
                    </div>
                }
                <div div className='input-grp'>
                    <label>Mfg Date</label>
                    <TextInput
                        className="inputFocus"
                        type="date"
                        id="mfgDate"
                        name="mfgDate"
                        value={props.sampleObject.mfgDate}
                        onChange={(event) => props.handleChange(event, "mfgDate")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Exp Date</label>
                    <TextInput
                        className="inputFocus"
                        type="date"
                        id="expDate"
                        name="expDate"
                        value={props.sampleObject.expDate}
                        onChange={(event) => props.handleChange(event, "expDate")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Supplier</label>
                    <MultiSelectDropdown
                        drpIdentity="supplierId"
                        options={props.supplierList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParametersForItemName(selected, "supplierId")
                        }
                        allowSelectAll={false}
                        value={props.supplierList.filter(
                            (party) => party.value === props.sampleObject.supplierId
                        )}
                        className={props.validState?.error?.supplierId ? "errorInput" : ""}
                        isDisabled={props.sampleEntryType === 'FinishProducts' ? false : true}
                    />
                </div>
                <div className='input-grp col-span-2'>
                    <label>Mfg By</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="mfgBy"
                        name="mfgBy"
                        value={props.sampleObject.mfgBy}
                        onChange={(event) => props.handleChange(event, "mfgBy")}
                        disabled={props.sampleEntryType === 'FinishProducts' ? false : true}
                    />
                </div>
                {props.sampleEntryType !== 'FinishProducts' ?
                    <>
                        <div className='input-grp'>
                            <label>Cond. of Contr</label>
                            <TextInput
                                className="inputFocus"
                                type="text"
                                id="conditionOfContainer"
                                name="conditionOfContainer"
                                value={props.sampleObject.conditionOfContainer}
                                onChange={(event) => props.handleChange(event, "conditionOfContainer")}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>No of Contr</label>
                            <TextInput
                                className="inputFocus"
                                type="number"
                                id="noOfContainer"
                                name="noOfContainer"
                                value={props.sampleObject.noOfContainer}
                                onChange={(event) => props.handleChange(event, "noOfContainer")}
                            />
                        </div>
                    </>
                    : null}
                <div className='input-grp col-span-2'>
                    <label>Publ. Lab Name</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="labName"
                        name="labName"
                        value={props.sampleObject.labName}
                        onChange={(event) => props.handleChange(event, "labName")}
                    />
                </div>
                <div className="input-grp col-span-4">
                    <label>Remark</label>
                    <textarea
                        rows={2}
                        className="inputFocus"
                        type="text"
                        id="remark"
                        name="remark"
                        autocomplete="off"
                        value={props.sampleObject.remark}
                        onChange={(event) => props.handleChange(event, "remark")}
                    />
                </div>
                <div className='input-grp col-span-2'>
                    <label>Send Out Side for Complete Analysis</label>
                    <ToggleSwitch
                        checked={props.sampleObject.isOutSideAnalysis === 1}
                        onChange={props.handleToggle}
                    />
                </div>
            </div >
        </>
    )
}

export default RawMaterialSampleEntryInputs